import R from 'app/assets/R'
import { SvgPrinterIcon } from 'app/assets/svg-assets'
import { BaseSpace } from 'app/components/common/BaseSpace'
import BaseText from 'app/components/common/BaseText'
import { useTranslation } from 'react-i18next'
import { ModalComponent } from '../../components'

export const PrintContractModal = () => {
  const { t } = useTranslation()

  return (
    <ModalComponent
      iconOpenModal={<SvgPrinterIcon />}
      titleOpenModal={t(R.strings.print_contract)}
      titleModal={t(R.strings.print_contract)}
      renderContent={
        <BaseSpace>
          <BaseText children={'Khánh'} />
        </BaseSpace>
      }
    />
  )
}
